/* hc-rc.js - script de sections/customer-reviews-carousel.liquid, externalise le 19-08-2026 (defer). Le pas de defilement vient de data-scroll. */
document.addEventListener('DOMContentLoaded', function() {
  // Navigation functionality
  var section = document.querySelector('.reviews-transformation-section');
  var container = document.querySelector('.reviews-container');
  var prevButton = document.querySelector('.nav-button.prev');
  var nextButton = document.querySelector('.nav-button.next');
  if (!section || !container || !prevButton || !nextButton) return;

  var amount = parseInt(section.getAttribute('data-scroll'), 10) || 360;

  prevButton.addEventListener('click', function() {
    container.scrollBy({ left: -amount, behavior: 'smooth' });
  });

  nextButton.addEventListener('click', function() {
    container.scrollBy({ left: amount, behavior: 'smooth' });
  });
});